import { PRIVATE_TOP_PATH } from '@/constants/routes';
import { PrivateApp } from '@/routes/PrivateApp';
import { RouteObject } from 'react-router-dom';

export const privateRoutes: RouteObject[] = [
  {
    Component: PrivateApp,
    children: [
      {
        path: `${PRIVATE_TOP_PATH}/*`,
        lazy: async () => ({
          Component: (await import('@/features/theme/routes')).ThemeRoutes,
        }),
      },
      {
        path: '/saved-filter-alerts/*',
        lazy: async () => ({
          Component: (await import('@/features/saved-filter-alert/routes'))
            .SavedFilterAlertRoutes,
        }),
      },
      {
        path: '/analyze/*',
        lazy: async () => ({
          Component: (await import('@/features/analyze/routes')).AnalyzeRoutes,
        }),
      },
      {
        path: '/setup/*',
        lazy: async () => ({
          Component: (await import('@/features/setup/routes')).SetupRoutes,
        }),
      },
      {
        path: '/settings/*',
        lazy: async () => ({
          Component: (await import('@/features/settings/routes'))
            .SettingsRoutes,
        }),
      },
      {
        path: '/subscription/*',
        lazy: async () => ({
          Component: (await import('@/features/subscription/routes'))
            .SubscriptionRoutes,
        }),
      },
      {
        path: '/bookmark/*',
        lazy: async () => ({
          Component: (await import('@/features/bookmark/routes'))
            .BookmarkRoutes,
        }),
      },
      {
        path: '/organizations/*',
        lazy: async () => ({
          Component: (await import('@/features/organizations/routes'))
            .OrganizationsRoutes,
        }),
      },
      {
        path: '/tracking_reports/*',
        lazy: async () => ({
          Component: (await import('@/features/tracking/routes'))
            .TrackingRoutes,
        }),
      },
    ],
  },
];
